import styled, { css } from 'styled-components';
import { clampedInversedLerp } from '@lemonade-hq/ts-helpers';
import { isSsr } from '@lemonade-hq/cdk';
import {
  GIVEBACK2019_DESKTOP_BREAKPOINT,
  GIVEBACK2019_MOBILE_BREAKPOINT,
  isInGiveback2019MobileViewport,
} from '../../utils/browser';
import Giveback2019Paragraph from './RisingParagraph';
import Pill from './Pill';

const positioned = css`
  @media (max-width: ${GIVEBACK2019_MOBILE_BREAKPOINT}px) {
    left: 50%;
    right: 0;
    transform: translateX(-50%);
    top: ${props => `${props.mobileTop}px`};
    display: ${props => (props.hideMobile ? 'none' : 'table')};
  }

  top: ${props => props.top}px;
  left: ${props => (props.left !== undefined ? `${props.left}px` : 'auto')};
  right: ${props => (props.right !== undefined ? `${props.right}px` : 'auto')};
  position: absolute;
`;

const PositionedPill = styled(Pill)`
  ${positioned}
`;

const PositionedParagraph = styled(Giveback2019Paragraph)`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    text-align: left;
  }

  ${positioned}
  text-align: center;
`;

function time({ from, to }, { fromMobile, toMobile }, relativeScroll) {
  if (isSsr()) return 0;

  const isMobile = isInGiveback2019MobileViewport();
  return isMobile
    ? clampedInversedLerp(fromMobile, toMobile, relativeScroll)
    : clampedInversedLerp(from, to, relativeScroll);
}

export default function RisingParagraphsContainer({ relativeScroll: rs }) {
  return (
    <>
      <PositionedPill
        top={1434}
        mobileTop={995}
        time={time({ from: 0.06, to: 0.09 }, { fromMobile: 0.06, toMobile: 0.08 }, rs)}
        hashTag="givebackfoodandwater"
        shareText="#givebackfoodandwater 💦 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @charitywater @UNICEF @ACLU @FeedingAmerica"
      />
      <PositionedParagraph
        top={1523}
        mobileTop={1047}
        title="Food packages"
        text="Sent to malnourished children via UNICEF ($16,904.15)"
        number={42589}
        time={time({ from: 0.08, to: 0.11 }, { fromMobile: 0.07, toMobile: 0.09 }, rs)}
      />
      <PositionedParagraph
        top={1730}
        mobileTop={1374}
        title="Hot meals"
        text="Delivered to elderly New Yorkers via Citymeals On Wheels ($56,757.95)"
        number={7663}
        time={time({ from: 0.09, to: 0.12 }, { fromMobile: 0.11, toMobile: 0.13 }, rs)}
      />
      <PositionedParagraph
        mobileTop={1168}
        top={1730}
        left={335}
        title="Lunches"
        text="Served in food banks across the U.S. via Feeding America ($2,406.00)"
        number={240}
        time={time({ from: 0.09, to: 0.12 }, { fromMobile: 0.08, toMobile: 0.1 }, rs)}
      />

      <PositionedParagraph
        top={1935}
        mobileTop={1495}
        title="Water Projects In Africa"
        text="Funded to provide people with safe, clean drinking water via charity: water ($51,759.19)"
        number={5}
        time={time({ from: 0.1, to: 0.13 }, { fromMobile: 0.12, toMobile: 0.14 }, rs)}
      />
      <PositionedParagraph
        top={1935}
        left={335}
        mobileTop={1617}
        title="Immigrants’ Rights Project"
        text="Supported to help reunite families at the border via ACLU ($51,386.42)"
        number={1}
        time={time({ from: 0.1, to: 0.13 }, { fromMobile: 0.14, toMobile: 0.16 }, rs)}
      />

      <PositionedPill
        top={2701}
        right={290}
        mobileTop={1980}
        time={time({ from: 0.19, to: 0.21 }, { fromMobile: 0.18, toMobile: 0.2 }, rs)}
        hashTag="GIVEBACKLGBTQPLUSEQUALITY"
        shareText="#givebacklgbtqplusequality 🏳️‍🌈 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @TrevorProject"
      />
      <PositionedParagraph
        top={2784}
        right={244}
        mobileTop={2035}
        title="LGBTQ+ youth"
        text="Granted life-saving intervention to end youth suicide via The Trevor Project ($50,495.71)"
        number={1683}
        time={time({ from: 0.2, to: 0.23 }, { fromMobile: 0.19, toMobile: 0.21 }, rs)}
      />

      <PositionedPill
        top={3517}
        left={80}
        mobileTop={2590}
        time={time({ from: 0.26, to: 0.29 }, { fromMobile: 0.24, toMobile: 0.26 }, rs)}
        hashTag="GIVEBACKMENTALHEALTHSUPPORT"
        shareText="#givebackmentalhealthsupport 💜 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @TWLOHA @CrisisTextLine"
      />
      <PositionedParagraph
        top={3600}
        left={80}
        mobileTop={2638}
        title="Emergency responses"
        text="Administered to those in a mental health crisis across the U.S. via Crisis Text Line ($3,585.00)"
        number={263}
        time={time({ from: 0.28, to: 0.31 }, { fromMobile: 0.26, toMobile: 0.28 }, rs)}
      />
      <PositionedParagraph
        top={3837}
        left={80}
        mobileTop={2763}
        title="Mental Health Programs"
        text="Created in 150 high schools across the U.S. via To Write Love On Her Arms ($27,652.32)"
        number={150}
        time={time({ from: 0.29, to: 0.32 }, { fromMobile: 0.27, toMobile: 0.29 }, rs)}
      />

      <PositionedPill
        top={4710}
        right={90}
        mobileTop={3330}
        time={time({ from: 0.37, to: 0.4 }, { fromMobile: 0.32, toMobile: 0.33 }, rs)}
        hashTag="GIVEBACKOUREARTH"
        shareText="#givebackourearth 🌍 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @SPCAINT @A4GL"
      />
      <PositionedParagraph
        top={4783}
        mobileTop={3380}
        right={-3}
        title="Dogs"
        text="Reunited with U.S. war veterans via SPCAI ($37,157.60)"
        number={1000}
        time={time({ from: 0.39, to: 0.42 }, { fromMobile: 0.325, toMobile: 0.335 }, rs)}
      />
      <PositionedParagraph
        top={4990}
        right={-3}
        mobileTop={3500}
        title="Beach"
        text="Cleaned up of plastic waste on the Great Lakes shore via Alliance for the Great Lakes ($13,144.34)"
        number={1}
        time={time({ from: 0.4, to: 0.43 }, { fromMobile: 0.336, toMobile: 0.346 }, rs)}
      />

      <PositionedPill
        top={6288}
        mobileTop={4140}
        time={time({ from: 0.52, to: 0.55 }, { fromMobile: 0.405, toMobile: 0.415 }, rs)}
        hashTag="GIVEBACKENDPOVERTY"
        shareText="#givebackendpoverty 👐 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @RobinHoodNYC @WINNYC_ORG @NewStoryCharity @TogetherWeRise"
      />
      <PositionedParagraph
        top={6369}
        mobileTop={4188}
        title="Jobs"
        text="Sourced for homeless mothers seeking employment in NYC via Women In Need ($4,704.41)"
        number={1000}
        time={time({ from: 0.53, to: 0.56 }, { fromMobile: 0.41, toMobile: 0.43 }, rs)}
      />
      <PositionedParagraph
        top={6596}
        mobileTop={4510}
        title="Foster kids"
        text="Received duffel bags, teddy bears, blankets, hygiene kits, and crayons via Together We Rise ($8,968.40)"
        number={58}
        time={time({ from: 0.54, to: 0.57 }, { fromMobile: 0.451, toMobile: 0.458 }, rs)}
      />
      <PositionedParagraph
        top={6369}
        mobileTop={4340}
        left={336}
        title="Low-income teenagers"
        text="Funded to attend middle school in NYC via Robin Hood ($4,889.30)"
        number={407}
        time={time({ from: 0.53, to: 0.56 }, { fromMobile: 0.435, toMobile: 0.445 }, rs)}
      />
      <PositionedParagraph
        top={6596}
        mobileTop={4644}
        left={336}
        title="3D printed home"
        text="Built in the world’s first ever 3D printed community in Haiti via New Story ($10,700.16)"
        number={1}
        time={time({ from: 0.54, to: 0.57 }, { fromMobile: 0.465, toMobile: 0.475 }, rs)}
      />

      <PositionedPill
        top={7630}
        right={404}
        mobileTop={5305}
        time={time({ from: 0.635, to: 0.665 }, { fromMobile: 0.54, toMobile: 0.56 }, rs)}
        hashTag="GIVEBACKTOCHILDREN"
        shareText="#givebacktochildren 🧒 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @thorn @nyspcc"
      />
      <PositionedParagraph
        top={7703}
        right={305}
        mobileTop={5353}
        title="Hours of counseling"
        text="Given to help abused children in New York via NYSPCC ($58,199.89)"
        number={1100}
        time={time({ from: 0.65, to: 0.68 }, { fromMobile: 0.56, toMobile: 0.58 }, rs)}
      />
      <PositionedParagraph
        top={7703}
        right={-10}
        mobileTop={5478}
        title="Trafficking victims"
        text="Identified daily with revolutionary Spotlight technology via Thorn ($26,729.91)"
        number={8}
        time={time({ from: 0.65, to: 0.68 }, { fromMobile: 0.58, toMobile: 0.6 }, rs)}
      />

      <PositionedPill
        top={8420}
        mobileTop={5845}
        time={time({ from: 0.69, to: 0.72 }, { fromMobile: 0.605, toMobile: 0.615 }, rs)}
        hashTag="GIVEBACKGLOBALHEALTH"
        shareText="#givebackglobalhealth 💊 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @RedCross @sloan_kettering @CUREchildcancer"
      />
      <PositionedParagraph
        top={8493}
        mobileTop={5893}
        title="Vaccinations"
        text="Administered to children worldwide for measles and rubella via American Red Cross ($45,571.32)"
        number={46571}
        time={time({ from: 0.71, to: 0.74 }, { fromMobile: 0.613, toMobile: 0.625 }, rs)}
      />
      <PositionedParagraph
        top={8715}
        mobileTop={6015}
        title="People Struggling With Addiction"
        text="Supported with addiction treatment throughout the U.S. via Shatterproof ($5,179.99)"
        number={259}
        time={time({ from: 0.71, to: 0.74 }, { fromMobile: 0.625, toMobile: 0.638 }, rs)}
      />
      <PositionedParagraph
        top={8715}
        left={323}
        mobileTop={6208}
        title="Child Cancer Patients"
        text="Financially supported throughout their cancer treatment via CURE Childhood Cancer ($43,013.82)"
        number={57}
        time={time({ from: 0.72, to: 0.75 }, { fromMobile: 0.64, toMobile: 0.66 }, rs)}
      />
      <PositionedParagraph
        top={8997}
        mobileTop={500}
        title="Breast Cancer Researchers"
        text="Funded for vital research via Breast Cancer Research Foundation ($7,547.44)"
        number={30}
        hideMobile
        time={time({ from: 0.74, to: 0.77 }, {}, rs)}
      />
      <PositionedParagraph
        top={8997}
        left={323}
        mobileTop={6345}
        title="Rare cancer trial"
        text="Funded and granted to Sloan Kettering Memorial via Cycle For Survival ($1,409.00)"
        number={1}
        time={time({ from: 0.74, to: 0.77 }, { fromMobile: 0.66, toMobile: 0.68 }, rs)}
      />

      <PositionedPill
        top={9623}
        right={338}
        mobileTop={6920}
        time={time({ from: 0.805, to: 0.835 }, { fromMobile: 0.72, toMobile: 0.73 }, rs)}
        hashTag="GIVEBACKEDUCATION"
        shareText="#givebackeducation 🏫 I just helped donate $631,540.07 to charities with my Lemonade policy. Insurance will never be the same #GoLemonade #Giveback2019 via @lemonade_inc @TeachForAmerica @CodeToInspire @PencilsOfPromis"
      />
      <PositionedParagraph
        top={9696}
        right={255}
        mobileTop={6968}
        title="Students"
        text="Supported in high-need communities across the U.S. with 3,600 new trained teachers via Teach For America ($32,827.34)"
        number={224000}
        time={time({ from: 0.815, to: 0.845 }, { fromMobile: 0.73, toMobile: 0.75 }, rs)}
      />
      <PositionedParagraph
        top={9696}
        right={-90}
        mobileTop={7110}
        title="Female coders"
        text="Given two years of safe schooling in Afghanistan via Code To Inspire ($13,687.23)"
        number={1000}
        time={time({ from: 0.815, to: 0.845 }, { fromMobile: 0.75, toMobile: 0.76 }, rs)}
      />
      <PositionedParagraph
        top={9933}
        right={255}
        mobileTop={7330}
        title="Computers"
        text="Given to Palestinian and Israeli entrepreneurs via MEET ($3,625.75)"
        number={7}
        time={time({ from: 0.825, to: 0.855 }, { fromMobile: 0.78, toMobile: 0.8 }, rs)}
      />
      <PositionedParagraph
        top={9933}
        right={-90}
        mobileTop={7450}
        title="Community Center"
        text="Donated to elementary school kids in after-school programs via Evolve Creative Alliance ($26,769.34)"
        number={1}
        time={time({ from: 0.825, to: 0.855 }, { fromMobile: 0.79, toMobile: 0.81 }, rs)}
      />
      <PositionedParagraph
        top={10150}
        right={255}
        mobileTop={7590}
        title="Year Of Classroom Technology"
        text="Provided to students in Laos, Guatemala, and Ghana via Pencils of Promise ($24,468.09)"
        number={1}
        time={time({ from: 0.835, to: 0.865 }, { fromMobile: 0.8, toMobile: 0.82 }, rs)}
      />
    </>
  );
}
